import { Client, IMessage } from '@stomp/stompjs';
import { Preferences } from '@capacitor/preferences';

export type MessengerRealtimeHandler = (event: any) => void;

let client: Client | null = null;
const handlers = new Set<MessengerRealtimeHandler>();

function notifyHandlers(event: any): void {
  handlers.forEach(handler => {
    try {
      handler(event);
    } catch (error) {
      console.warn('Messenger realtime handler failed', error);
    }
  });
}

/** Локальные события (resume/push) без WebSocket. */
export function notifyMessengerLocalEvent(event: Record<string, unknown>): void {
  notifyHandlers(event);
}

async function ensureConnected(): Promise<void> {
  if (handlers.size === 0) return;
  if (client?.active) return;

  if (client) {
    try {
      await client.deactivate();
    } catch {
      /* ignore */
    }
    client = null;
  }

  const { value: jwt } = await Preferences.get({ key: 'jwt' });
  const webJwt = localStorage.getItem('jhi-authenticationToken')?.replace(/^"|"$/g, '');
  const token = jwt || webJwt;
  if (!token) return;

  const apiBase = process.env.VUE_APP_API_URL || '';
  const brokerURL = apiBase.replace(/^http/i, 'ws').replace(/\/$/, '') + '/websocket';
  client = new Client({
    brokerURL,
    connectHeaders: { Authorization: `Bearer ${token}` },
    reconnectDelay: 5000,
    onConnect: () => {
      client?.subscribe('/user/queue/messenger', (message: IMessage) => {
        try {
          notifyHandlers(JSON.parse(message.body));
        } catch {
          notifyHandlers({ type: 'UNKNOWN' });
        }
      });
    },
  });
  client.activate();
}

/** Подписка на realtime; соединение общее для всех подписчиков. */
export function subscribeMessengerRealtime(handler: MessengerRealtimeHandler): () => void {
  handlers.add(handler);
  void ensureConnected();
  return () => {
    handlers.delete(handler);
    if (handlers.size === 0) {
      disconnectMessengerRealtime();
    }
  };
}

/** @deprecated используй subscribeMessengerRealtime */
export async function connectMessengerRealtime(handler: MessengerRealtimeHandler): Promise<void> {
  subscribeMessengerRealtime(handler);
}

export function disconnectMessengerRealtime(): void {
  if (client?.active) {
    void client.deactivate();
  }
  client = null;
}

/** После возврата из фона WS часто мёртв — переподключаем активных подписчиков. */
export function reconnectMessengerRealtime(): void {
  disconnectMessengerRealtime();
  if (handlers.size > 0) {
    void ensureConnected();
  }
}
